import React, { useEffect } from "react"
import _ from "lodash"
import { Control, useController, useWatch } from "react-hook-form"
import Select from "components/ReactHookForm/Select"
import { GuestStrategy as GuestStrategyType } from "sharedTypes/index"

type Props = {
  control: Control<object>
  label: string
}

const options = _.times(10, (index) => ({
  label: (index + 1).toString(),
  value: index + 1,
}))

// When a guest-creation strategy that reuses an existing profile is selected
// (prevent-duplicates / restrict-to-existing), a submission maps to a single
// guest, so "Max per Order" is forced to 1 and locked. Mirrors the backend
// validation on guestStrategy.
const MaxPerOrderField = ({ control, label }: Props) => {
  const guestStrategy = useWatch({ control, name: "guestStrategy" as never })
  const locked = guestStrategy === GuestStrategyType.Upsert
    || guestStrategy === GuestStrategyType.Restrict

  const { field } = useController({ control, name: "limitPerSubmission" as never })

  useEffect(() => {
    if (locked && field.value !== 1) {
      field.onChange(1)
    }
  }, [locked])

  return (
    <Select
      name="limitPerSubmission"
      control={control}
      label={label}
      options={options}
      disabled={locked}
      vertical
      fullWidth
    />
  )
}

export default MaxPerOrderField
